const destinations = {
  bot: {
    title: "1. Настройка Telegram-бота",
    description: "Ваши каналы и группы назначения используют один приватный токен Telegram-бота, связанный с текущим аккаунтом. Сохранённые токены не возвращаются в браузер и не передаются другим пользователям.",
    tokenLabel: "Токен Telegram-бота",
    placeholderNew: "123456789:ABCdefGhIJKlmNoPQRsTUVwxyZ",
    placeholderReplace: "Введите новый токен, чтобы заменить сохранённый",
    save: "Сохранить токен",
    saving: "Сохранение",
    showToken: "Показать токен бота",
    hideToken: "Скрыть токен бота",
    stored: "Сохранён безопасно",
    notConfigured: "Токен не настроен",
    acquirePrefix: "Получите токен у",
    acquireSuffix: "При сохранении учётные данные только вашего аккаунта записываются или заменяются в Supabase Vault.",
  },
  targets: {
    title: "2. Каналы и группы назначения",
    description: "Управляйте собственными публичными и приватными каналами и группами Telegram. Только текущий аккаунт может просматривать, изменять, тестировать и публиковать в эти назначения.",
    friendlyName: "Понятное название",
    friendlyNamePlaceholder: "например, Tech Announcements",
    channelId: "ID канала или имя пользователя",
    channelIdPlaceholder: "например, @my_channel или -100123456",
    add: "Добавить",
    addTarget: "Добавить назначение",
    emptyTitle: "Назначения пока не добавлены",
    emptyDescription: "Добавьте канал или группу назначения с понятным названием через форму выше.",
    active: "Активно",
    muted: "Выключено",
    toggle: "Переключить активность назначения {{name}}",
    connected: "Подключено",
    failed: "Ошибка",
    test: "Проверить подключение",
    testing: "Проверка подключения",
    remove: "Удалить назначение {{name}}",
  },
  feedback: {
    verificationSuccessful: "Проверка успешна",
    verificationFailed: "Проверка не удалась",
    saveTokenFirst: "Сначала безопасно сохраните токен Telegram-бота, затем проверяйте назначение.",
    verificationFallback: "Проверка не удалась.",
    testPublished: "Проверено! Тестовое сообщение опубликовано в {{channelId}}.",
    connectionFallback: "Не удалось подключиться. Проверьте токен бота и права администратора.",
    networkError: "Произошла непредвиденная ошибка сети.",
    enterToken: "Введите токен Telegram-бота перед сохранением.",
    tokenStored: "Токен бота безопасно сохранён для вашего аккаунта.",
    tokenSaveFailed: "Не удалось сохранить токен бота. Повторите попытку.",
    targetNameRequired: "Введите понятное название назначения.",
    channelIdRequired: "Введите ID Telegram-канала или имя пользователя.",
  },
  guide: {
    title: "Руководство по нескольким назначениям",
    intro: "Настройте приватного бота для публикации подготовленного контента в собственные каналы назначения. Другие пользователи TGReposter имеют отдельные токены и списки назначений.",
    adminTitle: "Назначьте права администратора",
    adminDescription: "Добавьте бота администратором в каждый канал или группу назначения и выдайте ему право «Публиковать сообщения».",
    privateTitle: "Поддержка приватных каналов",
    privateDescriptionPrefix: "Для приватных каналов получите числовой ID канала (обычно начинается с",
    privateDescriptionSuffix: "), переслав публикацию из канала диагностическому боту, например",
    multiTitle: "Мультипубликация",
    multiDescription: "При публикации из Content Inbox сервер отправляет сообщение во все отмеченные активные назначения.",
    footer: "Все назначения обрабатываются параллельно. Если одно временно недоступно или не имеет прав, остальные активные назначения всё равно могут получить публикацию.",
  },
} as const;

export default destinations;
